<template>
  <div class="agency fixed" :class="{'active': agency, 'hover': state !==7 }">
    <div class="purple"></div>
    <div class="blue"></div>
  </div>
</template>

<script>
export default {
  name: "WrapGrads",
  props: ['agency', 'state']
};
</script>

<style lang="scss" scoped>
.agency {
  left: 0%;
  transition: all 1s linear;
  top: -8%;
  div{
    border-radius: 50%;
  }

  .purple {
    position: absolute;
    width: 28.75rem;
    height: 28.75rem;
    left: 8.045rem;//8.045 //43.4375
    top: -20.603125rem;
    z-index: 2;
    background: linear-gradient(321.88deg, rgba(7, 25, 61, 0) 12.53%, rgba(242, 41, 89, 0.4) 43.45%, rgba(255, 0, 0, 0.4) 60.5%);
    filter: blur(3.75rem);
    transform: rotate(-22.14deg);
  }
  .blue {
    position: absolute;
    width: 28.75rem;
    height: 28.75rem;
    left: 16.77875rem;// 16.77875 //52.17125
    top: -16.019375rem;
    background: linear-gradient(344.88deg, rgba(7, 25, 61, 0) 12.53%, rgba(0, 133, 255, 0.4) 43.45%, rgba(255, 0, 0, 0.4) 60.5%);
    filter: blur(3.75rem);
    transform: rotate(-22.14deg);
  }
  .blue, .purple{
    transition: all .8s linear;
  }
}
.agency.active{
  transform: scale(.9);
  left: 6%;
  top: -10%;
  .purple{
    width: 40.93875rem;
    height: 40.93875rem;
    left: 27.375rem;
    top: -19.635rem;
  }
  .blue{
    width: 40.93875rem;
    height: 40.93875rem;
    left: 50.81125rem;
    top: -13.108125rem;
  }
}
.agency.hover{
  .blue, .purple{
    z-index: -10;
    transition: all .3s linear;
  }
}
</style>
